﻿import creator from "../elementCreator";

("use strict");

var privateFns, getInfo;

var kommuneplanDokument =
  "https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4";
privateFns = {
  appendHeader: function (text) {
    return creator.createH3({ text: text });
  },
  appendSubHeader: function (text) {
    var header = document.createElement("h4");
    return creator.createH4({ text: "<strong>" + text + "</strong>" });
  },
  appendLegendSection: function (text) {
    return creator.createSection({ css: "legend-section", text: text });
  },
  appendParagraph: function (text, classList) {
    return creator.createParagraph({ text: text, css: classList });
  },
  appendList: function (listItems) {
    var ul = creator.createUl({});
    listItems.forEach(function (item) {
      var li = creator.createLi({ text: item });
      ul.appendChild(li);
    });
    return ul;
  },
  appendIcon: function (icon) {
    return creator.createIcon({ css: icon });
  },
  appendLegendRow: function (symbClass, textClass, label) {
    var row = creator.createDiv({ css: "legend-row" });
    var symb = creator.createDiv({ css: symbClass, text: "&nbsp;" });
    row.appendChild(symb);
    var text = creator.createDiv({ text: label, css: textClass });
    row.appendChild(text);
    return row;
  },
  appendLegendImage: function (image, alternate) {
    return creator.createImage({ src: image, alt: alternate });
  },
  appendButton: function (classList, ariaLabel) {
    return creator.createButton({ ariaLabel: ariaLabel, css: classList });
  },
  appendDiv: function (id, classList, ariaLabel) {
    return creator.createDiv({ id: id, css: classList, ariaLabel: ariaLabel });
  },
  appendLink: function (id, title, href, ariaLabel) {
    return creator.createA({
      id: id,
      text: title,
      href: href,
      ariaLabel: ariaLabel,
    });
  },
  createElement(el) {
    if (el.type === "header") {
      return privateFns.appendHeader(el.text);
    } else if (el.type === "subHeader") {
      return privateFns.appendSubHeader(el.text);
    } else if (el.type === "legendSection") {
      return privateFns.appendLegendSection(el.text);
    } else if (el.type === "paragraph") {
      return privateFns.appendParagraph(el.text, el.classList);
    } else if (el.type === "list") {
      return privateFns.appendList(el.listItems);
    } else if (el.type === "icon") {
      return privateFns.appendIcon(el.icon);
    } else if (el.type === "legendRow") {
      return privateFns.appendLegendRow(el.symbClass, el.textClass, el.label);
    } else if (el.type === "legendImage") {
      return privateFns.appendLegendImage(el.image, el.alternate);
    } else if (el.type === "button") {
      return privateFns.appendButton(el.classList, el.ariaLabel);
    } else if (el.type === "div") {
      return privateFns.appendDiv(el.id, el.classList, el.ariaLabel);
    } else if (el.type === "link") {
      return privateFns.appendLink(el.id, el.title, el.href, el.ariaLabel);
    }
  },
};
getInfo = {
  test: [
    { type: "header", text: "header" },
    { type: "subHeader", text: "subheader" },
    { type: "legendSection", text: "legendSection" },
    { type: "paragraph", text: "paragraph" },
    {
      type: "list",
      listItems: [
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4' target='_blank'>kommuneplanens arealdel<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/282641/732bec14283e46262050936aaab6dc70567cb72f7b10bd14826a6eb583dc5c13' target='_blank'>kommunedelplan for Akerselva miljøpark<i class='icon-new-window'></i></a>",
      ],
    },
    { type: "icon", icon: "fa fa spinner" },
    {
      type: "legendRow",
      symbClass: "legend-symb legend-postliste",
      textClass: "legend-text",
      label: "Postliste",
    },
    {
      type: "legendImage",
      image:
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=VANN&service=wms&version=1.3.0&request=getLegendGraphic&layer=Vann&format=image/png&sld_version=1.1.0&v=1",
      alternate: "Stiplet rød linje viser bekker i rør. ",
    },
    { type: "div", id: "div", classList: "legend-symb", ariaLabel: "divLabel" },
    {
      type: "link",
      id: "linkId",
      title: "Link Tittle",
      href: "www.vg.no",
      ariaLabel: "linkLabel",
    },
  ],
  postliste: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Postliste"));
    el.appendChild(
      privateFns.appendParagraph(
        "Kartet viser alle saker hvor det har kommet inn dokumenter den siste uken, eller i valgt tidsrom.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-postliste",
        "legend-text",
        "Postliste",
      ),
    );
    return el;
  },
  kdp: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Kommunedelplaner"));
    el.appendChild(
      privateFns.appendParagraph(
        "En kommunedelplan er en overordnet plan vedtatt i Bystyret som gir tematiske og/eller geografiske føringer for et område.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I kartet kan du se planene som gir geografiske føringer. For å se alle kommunedelplanene, også de tematiske, <a target='_blank' href='https://www.oslo.kommune.no/plan-bygg-og-eiendom/planer-og-veiledere/kommunedelplaner/'>se kommunedelplaner <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Trykk på pilen ved siden av kartlaget for å se hvilke kommunedelplaner som finnes i kartet. Her kan du også slå av de du ikke vil se.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "For å se hva plankartet betyr, klikk i kartet og åpne undermenyen for kommunedelplaner. Da kan du få markert i kartet hvor og hva de ulike formålene er.",
      ),
    );

    return el;
  },
  reg: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Reguleringsplaner"));
    el.appendChild(
      privateFns.appendParagraph(
        "En reguleringsplan viser hva et areal kan brukes til. De ulike formålene har forskjellig fargekode.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        'Skru av og på de forskjellige kartlagene for å se etter regulering i forskjellige vertikalnivå. Et område som er regulert under bakken vil ikke være synlig i kartet dersom kartlaget "Regulert på bakkenivå" er slått på.',
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Hvis du klikker i kartet får du informasjon om planer som gjelder for akkurat dette stedet og hvilke formål som finnes der du klikket.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("<strong>Forenklet tegnforklaring:</strong>"),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-bolig",
        "legend-text",
        "Boligområde",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-friomraade",
        "legend-text",
        "Friområde",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-veigrunn",
        "legend-text",
        "Veigrunn",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-industri",
        "legend-text",
        "Industri",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-forretning",
        "legend-text",
        "Forretning/kontor",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-veiareal",
        "legend-text",
        "Annet veiareal",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-reg-offentlig",
        "legend-text",
        "Offentlige bygg og anlegg",
      ),
    );
    el.appendChild(privateFns.appendParagraph("..."));
    el.appendChild(
      privateFns.appendParagraph(
        "<a target='_blank' href='//od2.pbe.oslo.kommune.no/pages/legends/legend42_32.pdf'>Se hele tegnforklaringen <i class='fa fa-file-pdf-o'></i></a>",
      ),
    );
    return el;
  },
  planprogram: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Planprogram"));
    el.appendChild(
      privateFns.appendParagraph(
        "Her vises planprogrammer for utvikling av områder der det er aktuelt med flere ulike reguleringsplaner. Normalt utarbeides slike planprogram av Oslo kommune.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Et planprogram er et program for planarbeid i et gitt geografisk område. Planprogrammet utarbeides av den som har fremmet forslag til planen (forslagsstiller). Programmet skal redegjøre for",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "videre planprosesser",
        "ulike alternativer for utvikling",
        "hvilke konsekvenser som skal utredes før det kan vedtas en reguleringsplan i det aktuelle området",
      ]),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Hvis en reguleringsplan har vesentlige konsekvenser for miljø og samfunn, skal forslagsstiller utarbeide en konsekvensutredning. For planer som utløser krav om konsekvensutredning, skal det også utarbeides et planprogram. Planprogrammet skal legges ut til høring og offentlig ettersyn før det fastsettes av kommunen.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Planprogram kan også brukes for å fastsette rammebetingelser for arbeid med senere reguleringsplaner for et område. Dette gjelder også for flere ulike pågående eller etterfølgende reguleringsplaner.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-planprogram-fastsatt",
        "legend-text",
        "Fastsatt planprogram",
      ),
    );
    return el;
  },
  vpor: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Veiledende plan for offentlig rom"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "En veiledende plan for offentlig rom (VPOR) er en plan som skal sikre en helhetlig utvikling av gater og byrom i et område. VPOR er ikke forankret i plan- og bygningsloven, men et planverktøy utviklet av Oslo kommune til bruk i områder der mange ulike reguleringsplaner må samordnes for å sikre viktige sammenhenger i byen. Planen angir utformingsprinsipper for offentlig rom, dvs. gater, parker, torg og møteplasser.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "En VPOR er ikke i seg selv en juridisk bindende plan, men prinsippene som angis i planen, skal videreføres og sikres juridisk i påfølgende detaljreguleringsplaner. Planen gir også grunnlag for utbyggingsavtaler mellom grunneiere/utviklere og Oslo kommune om finansiering av nødvendig infrastruktur i et område.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-vpor-fastsatt",
        "legend-text",
        "Vedtatt VPOR",
      ),
    );
    return el;
  },
  tor: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Tiltaksliste for offentlig rom (TOR)"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Tiltaksliste for offentlig rom skal først og fremst være et arbeidsverktøy for og mellom kommunale etater i saksbehandlingen av de enkelte plan- og byggesaker i området, men de vil også bidra til å skape forutsigbarhet for utbyggere innenfor området. Tiltakslistene legges til grunn for utarbeidelse og behandling av reguleringsplaner i området, herunder det overordnede byplangrepet og hvilke tiltak det kan knyttes rekkefølgebestemmelser til. Videre gir tiltakslistene en helhetlig oversikt og rammer for kommunen når det skal fremforhandles utbyggingsavtaler. Tiltakslistene er ikke politisk behandlet, men administrativt fastsatt av de involverte kommunale etatene.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-tor",
        "legend-text",
        "TOR",
      ),
    );
    return el;
  },
  omraaderegulering: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Områderegulering"));
    el.appendChild(
      privateFns.appendParagraph(
        "Områderegulering utarbeides av kommunen. Den brukes der det er krav om en slik plan i kommuneplanens arealdel, eller kommunen mener at det er behov for å gi avklaringer av arealbruken i et område utover det som allerede er gitt i kommuneplanen.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "En områderegulering skal sikre sammenhenger i et større område. Den skal legge rammer for videre planlegging, utvikling og bygging, eller ivareta vernehensyn. Det kan settes krav i planen til utarbeiding av detaljregulering for deler av området.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "De ulike formålene i en områdereguleringsplan har samme fargekode som i detaljreguleringsplaner.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-omraaderegulering",
        "legend-text",
        "Pågående områderegulering",
      ),
    );
    return el;
  },
  detaljregulering: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Plansaker"));
    el.appendChild(
      privateFns.appendParagraph(
        "Viser reguleringsplaner/detaljregulering under arbeid. For noen planer vises det faktiske omrisset, men de fleste vises som omtrentlige sirkler.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Klikk på en pågående reguleringsplan i kartet for å lese mer om plansaken.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-plansaker",
        "legend-text",
        "Pågående plansaker",
      ),
    );
    return el;
  },
  planprogrampaagaaende: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Planprogram"));
    el.appendChild(
      privateFns.appendParagraph(
        "Her vises planprogrammer for utvikling av områder der det er aktuelt med flere ulike reguleringsplaner. Normalt utarbeides slike planprogram av Oslo kommune.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Et planprogram er et program for planarbeid i et gitt geografisk område. Planprogrammet utarbeides av den som har fremmet forslag til planen (forslagsstiller). Programmet skal redegjøre for",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "videre planprosesser",
        "ulike alternativer for utvikling",
        "hvilke konsekvenser som skal utredes før det kan vedtas en reguleringsplan i det aktuelle området",
      ]),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Hvis en reguleringsplan har vesentlige konsekvenser for miljø og samfunn, skal forslagsstiller utarbeide en konsekvensutredning. For planer som utløser krav om konsekvensutredning, skal det også utarbeides et planprogram. Planprogrammet skal legges ut til høring og offentlig ettersyn før det fastsettes av kommunen.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Planprogram kan også brukes for å fastsette rammebetingelser for arbeid med senere reguleringsplaner for et område. Dette gjelder også for flere ulike pågående eller etterfølgende reguleringsplaner.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-planprogram",
        "legend-text",
        "Planprogram under arbeid",
      ),
    );
    return el;
  },
  vporpaagaaende: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Veiledende plan for offentlig rom"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "En veiledende plan for offentlig rom (VPOR) er en plan som skal sikre en helhetlig utvikling av gater og byrom i et område. VPOR er ikke forankret i plan- og bygningsloven, men et planverktøy utviklet av Oslo kommune til bruk i områder der mange ulike reguleringsplaner må samordnes for å sikre viktige sammenhenger i byen. Planen angir utformingsprinsipper for offentlig rom, dvs. gater, parker, torg og møteplasser.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "En VPOR er ikke i seg selv en juridisk bindende plan, men prinsippene som angis i planen, skal videreføres og sikres juridisk i påfølgende detaljreguleringsplaner. Planen gir også grunnlag for utbyggingsavtaler mellom grunneiere/utviklere og Oslo kommune om finansiering av nødvendig infrastruktur i et område.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-vpor",
        "legend-text",
        "VPOR under arbeid",
      ),
    );
    return el;
  },
  markagr: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Markagrense"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er grensen for den delen av marka i Oslo der <a href='https://lovdata.no/dokument/NL/lov/2009-06-05-35?q=Markaloven' target='_blank'>markaloven <i class='icon-new-window'></i></a> gjelder. Grensen er bestemt i <a href='https://lovdata.no/dokument/SF/forskrift/2015-09-04-1032?q=Forskrift%20til%20endring%20av%20markaloven' target='_blank'>forskrift om justering av markagrensen <i class='icon-new-window'></i></a>.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-markagrense",
        "legend-text",
        "Markagrense",
      ),
    );
    return el;
  },
  plansak: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Plansaker"));
    el.appendChild(
      privateFns.appendParagraph(
        "Viser reguleringsplaner under arbeid. For noen planer vises det faktiske omrisset, men de fleste vises som omtrentlige sirkler. Her ser du også områder med varsel om og vedtak om midlertidige forbud mot tiltak. Klikk på en pågående plan i kartet for å lese mer om plansaken.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-plansaker",
        "legend-text",
        "Pågående plansaker",
      ),
    );
    return el;
  },
  kunngjoringer: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Plankunngjøringer"));
    el.appendChild(
      privateFns.appendParagraph(
        "Viser alle arealplaner i Oslo kommune som du kan uttale deg om, og vedtak du kan klage på.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-kunngjoring-oppstart",
        "legend-text",
        "Oppstart",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-kunngjoring-offentligettersyn",
        "legend-text",
        "Offentlig ettersyn",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-kunngjoring-vedtak",
        "legend-text",
        "Vedtak",
      ),
    );
    return el;
  },
  byggesak: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Byggesaker (pågående)"));
    el.appendChild(
      privateFns.appendParagraph(
        "Viser byggesaker som ikke er avsluttet, og som har inn- eller utgående korrespondanse i løpet av de 4 siste årene.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-byggesaker",
        "legend-text",
        "Pågående byggesaker",
      ),
    );
    return el;
  },
  eiendomssak: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Pågående eiendomssaker"));
    //el.appendChild(privateFns.appendParagraph("Viser delesaker som ikke er avsluttet"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-eiendomssaker",
        "legend-text",
        "Pågående eiendomssaker",
      ),
    );
    return el;
  },
  funnpotensiale: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Sannsynlighet for å finne fortidsminner"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Kartet viser hvor det er kartlagt fortidsminner. Hvis du skal grave eller bygge her, må Byantikvaren som kulturminnemyndighet ofte vurdere om det er behov for ytterligere arkeologiske undersøkelser.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom du ved inngrep i terreng finner kulturminner har du plikt til å stanse arbeidene og varsle kulturminnemyndigheten, jf. Kulturminnneloven § 8 (2).",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-funnpotensiale-high",
        "legend-text",
        "Høyt funnpotensiale",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-funnpotensiale-medium",
        "legend-text",
        "Middels høyt funnpotensiale",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-funnpotensiale-low",
        "legend-text",
        "Mindre funnpotensiale",
      ),
    );
    return el;
  },
  vann: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Åpent vann:"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom det er åpent vann i nærheten av eiendommen eller planområdet, kan det få betydning hvis du skal bygge eller omregulere.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Åpent vann kan blant annet være bekker, elver, innsjøer og Oslofjorden.",
      ),
    );
    el.appendChild(privateFns.appendHeader("Historiske bekkeløp:"));
    el.appendChild(
      privateFns.appendParagraph(
        "Historiske bekkeløp viser omtrent hvor det en gang rant en bekk. Røret som bekken er lagt i, er ikke nødvendigvis på samme sted.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom det er bekker og elver i rør i nærheten av eiendommen eller planområdet, kan det få betydning hvis du skal bygge eller omregulere.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom tiltaket berører en lukket elv eller bekk, skal Vann- og avløpsetaten og Bymiljøetaten vurdere gjenåpning av bekken eller elven.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Har du behov for å vite mer om de historiske bekkeløpene, som for eksempel hvor rørene går, må du ta kontakt med " +
          "<a href='https://www.oslo.kommune.no/vann-og-avlop/kart-og-tegninger/' target='_blank'>Vann- og avløpsetaten.</a>",
      ),
    );
    el.appendChild(privateFns.appendHeader("Planlegger du å bygge i området?"));
    el.appendChild(
      privateFns.appendParagraph(
        "Avstanden til bekker, elver og vann kan få betydning hvis du skal bygge eller omregulere.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom du skal sende inn en søknad om å bygge noe, må du sørge for å innhente uttalelser fra Vann- og avløpsetaten, Bymiljøetaten og/eller bydelen. I reguleringsplansaker vil også Norges vassdrags- og energidirektorat (NVE) gi en uttalelse.",
      ),
    );
    el.appendChild(
      privateFns.appendSubHeader(
        "Her kan du lese mer om Vann, bekker og elver",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4' target='_blank'>kommuneplanens arealdel<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/getfile.php/134059/Innhold/Plan%2C%20bygg%20og%20eiendom/Overordnede%20planer/Kommunedelplaner/Kommunedelplan%20for%20Alna%20milj%C3%B8park.pdf' target='_blank'>kommunedelplan for Alna miljøpark<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/282641/732bec14283e46262050936aaab6dc70567cb72f7b10bd14826a6eb583dc5c13' target='_blank'>kommunedelplan for Akerselva miljøpark<i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://www.oslo.kommune.no/plan-bygg-og-eiendom/plan-og-bygningsetatens-kundesenter/' target='_blank'>Ta kontakt med Plan- og bygningsetatens kundesenter  <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a> dersom du har spørsmål.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=VANN_NY&service=wms&version=1.3.0&request=getLegendGraphic&layer=Vann&format=image/png&sld_version=1.1.0&v=1",
        "Stiplet rød linje viser bekker i rør. Heltrukken lyseblå linje viser bekker, kanaler og grøfter. Lyseblå flater viser vann og elver. Tykke linjer med vekselsvis rød og hvit farge viser bekker og elver i tunnel.",
      ),
    );
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=VANN_NY&service=wms&version=1.3.0&request=getLegendGraphic&layer=Vannflater_tegn&format=image/png&sld_version=1.1.0&v=1",
        "Stiplet rød linje viser bekker i rør. Heltrukken lyseblå linje viser bekker, kanaler og grøfter. Lyseblå flater viser vann og elver. Tykke linjer med vekselsvis rød og hvit farge viser bekker og elver i tunnel.",
      ),
    );
    return el;
  },
  fjernvarme: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Konsesjonsområde for fjernvarme"));
    el.appendChild(
      privateFns.appendParagraph(
        "I konsesjonsområdene for fjernvarme kan det være krav om at nye bygg blir tilknyttet fjernvarmeanlegget. Kommuneplanen krever tilknytning for alle nybygg på over 1000 m² BRA. Det gjelder også ombygging og tilbygg og påbygg til slike. Hvis du bruker andre typer oppvarming som er mer miljøvennlig, er det mulig å få unntak fra tilknytningsplikten.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Detaljreguleringer der bygningsmassen blir større enn 1000 m² BRA, skal inneholde bestemmelser om tilknytning til fjernvarmeanlegg.",
      ),
    );
    el.appendChild(
      privateFns.appendSubHeader(
        "Her kan du lese mer om tilknytning til fjernvarme",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=21' target='_blank'>kommuneplanen § 4.3<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/1625568/b0ffc1cda16553a4b82d0953c9400ce2acace72898a3713c2c6c938610c7daef' target='_blank'>veileder til reguleringsbestemmelser<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/282383/c379502c37690125f1fb446623666d40a2fd5a5f7f166ade4e77e8449212c470' target='_blank'>unntaksvurderingen i retningslinjer for tilknytningsplikt til fjernvarmeanslegg<i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=FJERNVARME&service=wms&version=1.3.0&request=getLegendGraphic&layer=Fjernvarme&format=image/png&sld_version=1.1.0&v=2",
        "Stiplet rød linje viser bekker i rør. Heltrukken lyseblå linje viser bekker, kanaler og grøfter. Lyseblå flater viser vann og elver. Tykke linjer med vekselsvis rød og hvit farge viser bekker og elver i tunnel.",
      ),
    );
    return el;
  },
  naturmangfold: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Naturmangfold (verdifull natur)"));
    el.appendChild(
      privateFns.appendParagraph(
        "Naturmangfold er et samlebegrep for biologisk mangfold, landskapsmessig mangfold og geologisk mangfold som i liten grad er preget av inngrep fra mennesker. Kartet viser viktige og utvalgte naturtyper (f.eks. hul eik og kalklindeskog), registrerte funn av prioriterte arter (dragehode), andre biologisk viktige områder (f.eks. viktige områder for viltet og marine naturtyper) og verneområder.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Vi må ta hensyn når vi planlegger og bygger i områder hvor det er registrert verdifull natur. Derfor kreves det blant annet en uttalelse fra Bymiljøetaten i plan- og byggesaker. Hvilke regler som gjelder, er avhengig av hva som er registrert på eiendommen din.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Det kan også forekomme større enkelttær etc. som bør bevares selv om de ikker er registrert i kommunens naturmangfoldsregister. De må du også ta hensyn til i plan- og byggesaker.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Ta kontakt med Bymiljøetaten for å få mer informasjon om hvilken type verdifull natur som er registrert på eiendommen. Du kan deretter kontakte Plan- og bygningsetaten for å få informasjon om hvordan dette påvirker en eventuell plan- eller byggesak.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Vær oppmerksom på at kommuneplanen har et eget temakart for naturmiljø, og at planen legger føringer for hvordan ulike naturtyper skal ivaretas i plan- og byggesaker. Småhusplanen og reguleringsplanene for Nordstrandskråningen, Vettakollen og Holmenkollen har også egne bestemmelser om dette.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Uønskede arter"));
    el.appendChild(
      privateFns.appendParagraph(
        "Uønskede arter er arter som kan gi økologiske konsekvenser og som ikke hører hjemme i norsk natur. I Oslo gjelder dette særlig planteartene kjempebjørnekjeks, kjempespringfrø og russesvalerot. For å unngå spredning er det blant annet viktig at byggeavfall håndteres riktig. Bymiljøetaten skal uttale seg om tiltak på eiendommer med uønskede arter. Ta kontakt med Bymiljøetaten for å få mer informasjon om de uønskede, fremmede artene.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-verdifull-natur",
        "legend-text",
        "Verdifull natur",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-fremmede-arter",
        "legend-text",
        "Uønskede arter",
      ),
    );
    return el;
  },
  forurenset_grunn: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Forurenset grunn"));
    el.appendChild(
      privateFns.appendParagraph(
        "Kartet for forurenset grunn omfatter hensynssoner der det er påvist eller kan være forurenset grunn.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom du skal bygge i området, må du sørge for at grunnen undersøkes. Hvis grunnen er forurenset, må du sørge for å få utarbeidet en tiltaksplan for forurenset grunn og fjerne eller sikre massene i tråd med kravene i forurensningsforskriften kapittel 2. Innenfor hensynssonen for forurenset grunn må du ha tillatelse fra Plan- og bygningsetaten før du kan sette i gang søknadspliktige bygge- og gravearbeider. Plan- og bygningsetaten skal også godkjenne tiltaksplanen før du kan gjøre terrenginngrep. Dette gjelder også terrenginngrep som ikke er søknadspliktige etter plan- og bygningsloven.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Hvis du skal gjøre terrenginngrep på nedlagte avfallsdeponier, må du hente inn en uttalelse fra Eiendoms- og byfornyelsesetaten og samtykke fra Fylkesmannen i Oslo og Akershus. Dette skal du sende inn til Plan- og bygningsetaten sammen med tiltaksplanen.",
      ),
    );
    el.appendChild(
      privateFns.appendSubHeader("Her kan du lese mer om forurenset grunn"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=29' target='_blank'>kommuneplanen § 14.5  om hensynssone forurenset grunn<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner<i class='icon-new-window'></i></a>",
        "<a href='https://lovdata.no/dokument/NL/lov/2008-06-27-71/KAPITTEL_4-9#§28-1' target='_blank'>plan- og bygningsloven § 28-1<i class='icon-new-window'></i></a>",
        "<a href='https://dibk.no/byggereglene/byggteknisk-forskrift-tek17/9/9-3/' target='_blank'>byggteknisk forskrift (TEK17) § 9-3 Forurensning i grunnen<i class='icon-new-window'></i></a>",
        "<a href='https://lovdata.no/dokument/SF/forskrift/2004-06-01-931' target='_blank'>forurensningsforskriften<i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-forurenset-aktsomhet",
        "legend-text",
        "Aktsomhetssone",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-forurenset-forurenset",
        "legend-text",
        "Forurenset grunn",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-forurenset-potensielle",
        "legend-text",
        "Potensielle forurensingskilder",
      ),
    );

    return el;
  },
  maringrense: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Maringrense"));
    el.appendChild(
      privateFns.appendParagraph(
        "Du kan ikke bygge noe som kan utløse eller rammes av kvikkleireskred. <i>Under den marine grensen kan det finnes kvikkleire.</i> Kvikkleire er marin leire der saltet som binder leiren sammen, over tid har blitt vasket bort. Dermed blir strukturen ustabil, og økte belastninger, som for eksempel gravearbeider, fyllinger eller kraftige vibrasjoner, kan utløse skred. <a href='//od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_kvikkleireskred.html' target='_blank'>Du finner mer informasjon om kvikkleire i vårt faktaark <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a>.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dersom du skal bygge innenfor dette området, må du sørge for at det vurderes om det er nødvendig med geotekniske undersøkelser av grunnen. For reguleringsplaner må det foretas geotekniske prøveboringer, for å fastslå om det finnes kvikkleire eller ikke. Det kan være nødvendig med spesiell ansvarsbelegging i en byggesak. Det er gjort et stort antall grunnboringer i Oslo, og i noen tilfeller vil det være mulig å gjenbruke eksisterende data. Ta kontakt med kommunen på e-post <a href='mailto:dig.kart@pbe.oslo.kommune.no'>dig.kart@pbe.oslo.kommune.no</a> eller telefon 23 49 10 00 for å finne ut hvilken informasjon som finnes om din tomt.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<strong>Her kan du lese mer om marin grense og kvikkleire</strong>",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=29' target='_blank'>kommuneplanen § 14.3 første ledd om kvikkleire<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=106' target='_blank'>vedlegg 2 til kommuneplanen om risiko- og sårbarhetsanalyse, kapittel 17.2.4<i class='icon-new-window'></i></a>",
        "<a href='https://lovdata.no/dokument/NL/lov/2008-06-27-71/KAPITTEL_4-9#§28-1' target='_blank'>plan- og bygningsloven § 28-1<i class='icon-new-window'></i></a>",
        "<a href='https://dibk.no/byggereglene/byggteknisk-forskrift-tek17/7/7-3/' target='_blank'>byggteknisk forskrift (TEK17) § 7-3 Sikkerhet mot skred<i class='icon-new-window'></i></a> (se veiledning til 2. ledd, bokstav B. Kvikkleireskred)",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.maringrense_legend());
    return el;
  },
  drenering: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Dreneringslinjer"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dreneringslinjene viser hvor det er sannsynlig at vannet vil renne dersom kulverter, stikkrenner og rørsystem er utilgjengelig.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Kartet utelukker ikke flomfare i andre områder og kan derfor kun brukes som et utgangspunkt for videre undersøkelser. <a href='//od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_dreneringslinjer.html' target='_blank'>Du finner mer informasjon om dreneringslinjer i vårt faktaark <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a>.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "</p><p>Du kan ikke bygge noe som kan utløse eller rammes av flom. Dersom du skal bygge i nærheten av en dreneringslinje, må du sørge for at sannsynligheten for flom kartlegges nærmere. Kartleggingen gjøres i forbindelse med en sikkerhets- og sårbarhetsanalyse (ROS-analyse) når det blir utarbeidet en reguleringsplan, eller senest i byggesaken. I en byggesak skal du også dokumentere at den nye bebyggelsen er sikret i henhold til regelverket. Det kan også være nødvendig med spesielle ansvarsretter i saken.</p><p></p><strong>Her kan du lese mer om dreneringslinjer</strong></p><p></p>",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4#page=21' target='_blank'>kommuneplanen § 4.2 om avløp og overvann<i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.dreneringslinjer_legend());
    return el;
  },
  veitype: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Vegtype"));
    el.appendChild(
      privateFns.appendParagraph(
        "Vegloven bestemmer hvor langt du kan bygge fra gangvei, kommunal vei og riksvei, dersom ikke annet er oppgitt i reguleringsplanen for området. For å finne ut hvor byggegrensen går, må du finne veitypen og hvilken veglov som gjaldt da reguleringsplanen ble vedtatt.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Veglovens bestemmelser gjelder imidlertid ikke dersom reguleringsplanen definerer hvor langt du kan bygge fra veien. Avstanden kan for eksempel være definert gjennom en byggegrense eller en byggelinje.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her er en oversikt over byggegrensen til vei i de ulike veglovene:",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<table class = 'helpTextTable' ><tr><th>Tidsrom</th><th>Avstand til kommunal vei</th><th>Avstand til riksvei</th><th>Mål avstanden fra</th></tr><tr><td>1912 - 1931</td><td>3,5 meter</td><td>3,5 meter</td><td>regulert veikant</td></tr><tr><td>1931 - 1938</td><td>5,0 meter</td><td>5,0 meter</td><td>regulert veikant</td></tr><tr><td>1938 - 1964</td><td>7,5 meter</td><td>7,5 meter</td><td>regulert veikant</td></tr><tr><td>1. januar 1964 - 30. juni 1996</td><td>12,5 meter</td><td>30,0 meter</td><td>veiens regulerte midtlinje</td></tr><tr><td>1. juli 1996 - 31. desember 2009</td><td>15,0 meter</td><td>50,0 meter</td><td>veiens regulerte midtlinje</td></tr><tr><td>1. januar 2010 - nå</td><td>15,0 meter</td><td>50,0 meter</td><td>veiens regulerte midtlinje</td></tr></table>",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Vær oppmerksom på at vegloven også sier at avstanden til sykkelvei skal være 15 meter.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.vegkategori_legend());
    return el;
  },
  fartsgrenser: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Fartsgrenser"));
    el.appendChild(
      privateFns.appendParagraph(
        "Fartsgrenser påvirker hvor god sikt du må ha i en avkjørsel.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Fartsgrensen har derfor betydning for hvor du kan plassere en avkjørsel og/eller et byggetiltak.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Se eksempel for <a href='https://www.oslo.kommune.no/get-file/110805/6c6849ada5434be08681dd2a2b790a98448f87e55938d4ce9a4160a70d635d8a' target='_blank'>indre sone (områder med kvartalsstruktur) <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a> og <a href='https://www.oslo.kommune.no/get-file/110806/909f0acd9a08c26f0e3153c729e6767b9dea242df199da5ecaf9b5fbcde8eefc' target='_blank'>ytre sone (områder med småhuskarakter) <i class='icon-new-window vd-glyphlink glyphicons new_window_alt'></i></a>",
      ),
    );
    return el;
  },
  trafikkmengde: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Trafikkmengde ÅDT"));
    el.appendChild(
      privateFns.appendParagraph(
        "Trafikkmengde i veier og gater måles i årsdøgntrafikk (ÅDT) som er gjennomsnittlig antall kjøretøy per døgn i løpet av et helt år.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Det finnes en del faste tellepunkter for ÅDT, blant annet i bomstasjoner. I tillegg er det over årene utført mange lokale trafikkregistreringer som er lagt inn i kommunale og statlige trafikkdatabaser. I en del mindre veier og gater, er det ikke foretatt trafikkregistreringer, her er trafikkmengde fastsatt skjønnsmessig.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I plansaker er ÅDT-statistikk nyttig da det gir mulighet til å se på trafikkutviklingen over tid, samt vurdere støy, luftforurensning og arealbruk langs veiene. ÅDT brukes som grunnlag når det skal settes prognoser for fremtidig trafikkmengde og når det skal utføres modellberegninger av kapasitet i veinett og kryss.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I byggesaker vil ÅDT være med på å påvirke plassering av avkjørsler og adkomster og utforming som gir trafikksikkerhet for gående og syklende.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=AADT&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=AADT_fastskala&format=image/png",
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=AADT&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=AADT_fastskala&format=image/png",
      ),
    );
    return el;
  },
  omreg: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Områderegulering"));
    el.appendChild(
      privateFns.appendParagraph(
        "Områderegulering utarbeides av kommunen. Den brukes der det er krav om en slik plan i kommuneplanens arealdel, eller kommunen mener at det er behov for å gi avklaringer av arealbruken i et område utover det som allerede er gitt i kommuneplanen.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "En områderegulering skal sikre sammenhenger i et større område. Den skal legge rammer for videre planlegging, utvikling og bygging, eller ivareta vernehensyn. Det kan settes krav i planen til utarbeiding av detaljregulering for deler av området.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "De ulike formålene i en områdereguleringsplan har samme fargekode som i detaljreguleringsplaner.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=REGTILLEGG&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Omraadeplan&format=image/png",
      ),
    );
    return el;
  },
  gulliste: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Gul liste"));
    el.appendChild(
      privateFns.appendParagraph(
        "Gul liste er Byantikvarens oversikt over kulturminner med eller uten formelt vern. Eiendommen kan ha en eller flere statuser, som har forskjellig betydning for en eventuell plan- eller byggesak.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(privateFns.appendParagraph("<strong>Enkeltminner</strong>"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-enkeltminne-fredet-kulturminne",
        "legend-text",
        "Fredet kulturminne",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-enkeltminne-regulert-til-bevaring",
        "legend-text",
        "Regulert til bevaring",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-enkeltminne-kulturminneinteresse",
        "legend-text",
        "Listeført kulturminne",
      ),
    );
    el.appendChild(privateFns.appendParagraph("<strong>Lokaliteter</strong>"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-lokalitet-fredet-kulturminne",
        "legend-text",
        "Automatisk fredet lokalitet",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-lokalitet-annet",
        "legend-text",
        "Andre lokalitetsgrenser",
      ),
    );
    el.appendChild(privateFns.appendParagraph("<strong>Sikringssone</strong>"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-sikringssone",
        "legend-text",
        "Sikringssone",
      ),
    );
    el.appendChild(privateFns.appendParagraph("<strong>Kulturmiljø</strong>"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-kulturmiljo",
        "legend-text",
        "Kulturmiljø",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='//od2.pbe.oslo.kommune.no/pages/vedlegg/gulliste.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );

    return el;
  },
  hovinbyen: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Strategisk plan for Hovinbyen"));
    el.appendChild(
      privateFns.appendParagraph(
        "Strategisk plan for Hovinbyen gir rammer for byutvikling av Hovinbyområdet de neste tiårene. Planen viser et overordnet grep, samt strategier og tiltak for videre utvikling. Hovinbyen transformeres fra å være et område preget av store lager- og industriarealer, til å bli et attraktivt byområde med mange nye boliger og arbeidsplasser. Planen er retningsgivende, men ikke juridisk bindende.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Mål for Hovinbyen"));
    el.appendChild(
      privateFns.appendList([
        "Hovinbyen skal være en fremtidsrettet og klimasmart byutvidelse",
        "Hovinbyen skal ha et mangfold av attraktive byområder som er tett sammenvevd med hverandre og resten av byen",
        "Gange, sykkel og kollektiv skal være de enkleste og mest attraktive måtene å ferdes på",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-hovinbyen-planomradet",
        "legend-text",
        "Planområdet",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-hovinbyen-aksene",
        "legend-text",
        "Aksene",
      ),
    );
    el.appendChild(
      privateFns.appendLegendRow(
        "legend-symb legend-hovinbyen-ringen",
        "legend-text",
        "Den grønne ringen",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2020010672&fileid=9127592' target='_blank'>Se hele planen<i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://innsyn.pbe.oslo.kommune.no/saksinnsyn/casedet.asp?direct=Y&mode=&caseno=201312256' target='_blank'>Se saksdokumenter<i class='icon-new-window'></i></a>",
      ),
    );

    return el;
  },
  torshovkvartalene: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Torshovkvartalene"));
    el.appendChild(
      privateFns.appendParagraph(
        "Her vises kart over juridisk bindende retningslinjer for estetisk utforming av takendringer i Torshovkvartalene.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Målet er å bevare områdets estetiske kvaliteter, samtidig som det tilrettelegges for boligforbedringer.",
      ),
    );
    el.appendChild(privateFns.appendParagraph("For utdypende informasjon, se"));
    el.appendChild(
      privateFns.appendList([
        "<a href='https://lovdata.no/dokument/LF/forskrift/2001-10-17-1444' target='_blank'>forskrift om juridisk bindende retningslinjer for endringsarbeider på tak, Torshovkvartalene, Oslo.<i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/282498/7b62aed2a2ad193fef94f2ef43f8b25f6f96d8f7128831bfde3ef2b2e2911ef9' target='_blank'>rapport for Torshovkvartalene (veileder) <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=d:/data_mapserver/kartfiler/Torshov.map&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Torshov&format=image/png&STYLE=default",
        "Tegnforklaring for torshovkvartalene",
      ),
    );

    return el;
  },
  dreneringslinjer_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb' ><div class='line-legend-drenering-50000-line'></div><div class='line-legend-drenering-50000 legend-sub-symb'></div></div><div class='legend-text-w'>Drenering 50000 m²</div></div>" +
          "<div class='legend-row'><div class='legend-symb' ><div class='line-legend-drenering-5000-line'></div><div class='line-legend-drenering-5000 legend-sub-symb'></div></div><div class='legend-text-w'>Drenering 5000 m²</div></div>",
      ),
    );
    return ct;
  },
  maringrense_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-marin-grense'></div><div class='legend-text-w'>Områder under marin grense</div></div>",
      ),
    );
    return ct;
  },
  vegkategori_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb2' ><div class='line-legend-veg-e-r'></div></div><div class='legend-text-w'>Riksvei</div></div>" +
          "<div class='legend-row'><div class='legend-symb2' ><div class='line-legend-veg-e-r-tunnel'></div></div><div class='legend-text-w'>Riksvei (tunnel)</div></div>" +
          "<div class='legend-row'><div class='legend-symb2' ><div class='line-legend-veg-e-r-gang-sykkel'></div></div><div class='legend-text-w'>Gang- og sykkelvei langs riksvei</div></div>" +
          "<div class='legend-row'><div class='legend-symb2' ><div class='line-legend-veg-k'></div></div><div class='legend-text-w'>Kommunal vei</div></div>" +
          "<div class='legend-row'><div class='legend-symb2' ><div class='line-legend-veg-k-gang-sykkel'></div></div><div class='legend-text-w'>Gang- og sykkelvei langs kommunal vei</div></div>" +
          "<div class='legend-row'><div class='legend-symb2' ><div class='line-legend-veg-p'></div></div><div class='legend-text-w'>Privat vei</div></div>",
      ),
    );
    return ct;
  },
  arealformaal_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Bebyggelse og anlegg</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-1001-1'>&nbsp;</div> <div class='legend-text-w'>Bebyggelse og anlegg (nåværende)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-1001-2'>&nbsp;</div> <div class='legend-text-w'>Bebyggelse og anlegg (fremtidig)</div> </div>",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Samferdselsanlegg og teknisk infrastruktur</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-2020-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende bane</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-2040-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende havn</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-2040-2'>&nbsp;</div> <div class='legend-text-w'>Fremtidig havn</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-2070-2'>&nbsp;</div> <div class='legend-text-w'>Fremtidig kollektivknutepunkt</div> </div> ",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Grønnstruktur</strong><div class='legend-row'>" +
          "<div class='legend-symb legend-3001-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende grøntstruktur</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-3001-2'>&nbsp;</div> <div class='legend-text-w'>Fremtidig grøntstruktur</div> </div> ",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Forsvaret</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-4001-1'>&nbsp;</div> <div class='legend-text-w'>Forsvaret</div> </div>",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Landbruks-, natur- og friluftsområder</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-5100-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende LNF-areal</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-5100-2'>&nbsp;</div> <div class='legend-text-w'>Fremtidig LNF-areal</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-5210-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende spredt boligbebyggelse</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-5210-2'>&nbsp;</div> <div class='legend-text-w'>Fremtidig spredt boligbebyggelse</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-5220-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende spredt fritidsbebyggelse</div> </div>",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Bruk og vern av sjø og vassdrag med tilhørende strandsone</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-6001-1'>&nbsp;</div> <div class='legend-text-w'>Bruk og vern av sjø og vassdrag</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-6200-1'>&nbsp;</div> <div class='legend-text-w'>Farled</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-6230-1'>&nbsp;</div> <div class='legend-text-w'>Eksisterende småbåthavn</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-6230-2'>&nbsp;</div> <div class='legend-text-w'>Fremtidig småbåthavn</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-6600-1'>&nbsp;</div> <div class='legend-text-w'>Naturområde</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-6700-1'>&nbsp;</div> <div class='legend-text-w'>Friluftsområde</div> </div>",
      ),
    );
    return ct;
  },
  hensynssoner_1_2_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Sone med angitte særlige hensyn</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-H570'>&nbsp;</div> <div class='legend-text-w'>Bevaring kulturmiljø (H 570)</div> </div>",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Båndleggingssone</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-H710'>&nbsp;</div> <div class='legend-text-w'>Båndlegging – naturmiljø (H 710)</div> </div>",
      ),
    );
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Gjennomføringssone</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-H810_1'>&nbsp;</div> <div class='legend-text-w'>Krav om godkjent områderegulering (H 810-1)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-H810_2'>&nbsp;</div> <div class='legend-text-w'>Krav om felles planlegging (H 810-2)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-H820_1'>&nbsp;</div> <div class='legend-text-w'>Hensynssone for høyspentlinje (H 820-1)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-H820_2'>&nbsp;</div> <div class='legend-text-w'>Hensynssone for trafostasjoner (H 820-2)</div> </div>",
      ),
    );
    return ct;
  },
  juridisk_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Farled</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1161-2-1'>&nbsp;</div><div class='legend-text-w'>Farled – ferdselsåre i sjø</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Jernbane</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1151-1-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende jernbanetunnel</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1151-1-2'>&nbsp;</div><div class='legend-text-w'>Fremtidig jernbanetunnel</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1151-2-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende jernbane</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1151-2-2'>&nbsp;</div><div class='legend-text-w'>Fremtidig jernbane</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Sporveg</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1152-2-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende sporveg</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1152-2-2'>&nbsp;</div><div class='legend-text-w'>Fremtidig sporveg</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1152-1-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende sporveistunnel</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1152-1-2'>&nbsp;</div><div class='legend-text-w'>Fremtidig sporveistunnel</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Fjernveg (europaveg)</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1121-2-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende europaveier og riksveier</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1121-1-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende europaveier og riksveier i tunnel</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Kollektivknutepunkt</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-1159-1'>&nbsp;</div><div class='legend-text-w'>Eksisterende kollektivknutepunkt</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-1159-2'>&nbsp;</div><div class='legend-text-w'>Fremtidig kollektivknutepunkt</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Bestemmelsesgrenser</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-bestgrense'>&nbsp;</div><div class='legend-text-w'>Indre by</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-bestgrense'>&nbsp;</div><div class='legend-text-w'>Ring 1</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-bestgrense'>&nbsp;</div><div class='legend-text-w'>Ankringsområder for skip</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-best-marka'>&nbsp;</div><div class='legend-text-w'>Aktivitetssoner i marka</div></div>",
      ),
    );
    //"<div class='legend-row'><div class='legend-symb legend-best-marka'>&nbsp;</div><div class='legend-text-w'>Aktivitetssoner i marka<br />Områder som åpner for tilrettelegging av utendørs aktiviteter og friluftsliv</div></div>"));

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Turveg/turdrag</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1140-2-2'>&nbsp;</div><div class='legend-text-w'>Fremtidig turvei/turdrag</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Grenser</strong>" +
          //"<div class='legend-row'><div class='legend-symb legend-symb-line legend-1163'>&nbsp;</div><div class='legend-text-w'>Markagrense<br />Grensen viser hvor markaloven gjelder. Her gjelder et generelt byggeforbud. Bygging her krever tillatelse både fra Fylkesmannen og kommunen</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-1163'>&nbsp;</div><div class='legend-text-w'>Markagrense</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-KpGrense'>&nbsp;</div><div class='legend-text-w'>Plangrense</div></div>",
      ),
    );

    return ct;
  },
  ikke_juridisk_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Samferdsel</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-fjernveg_ikke_juridisk'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Mulige fremtidige europaveier og riksveier</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-fjernveg_tunnel_ikke_juridisk'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Mulige fremtidige europaveier og riksveier i tunnel</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-fjernveg_lokk'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Mulige fremtidige europaveier og riksveier med lokkoverbygning</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-fjernveg_lokk_tunnel'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Mulige fremtidige europaveier og riksveier med lokkoverbygning eller i tunnel</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Mulig banetrasé</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-mulig_banetrase_ikke_juridisk'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Mulige fremtidige banetraséer</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Sporveg (fjordtrikk)</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-sporveg_ikke_juridisk'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Mulig fremtidig fjordtrikktrasé</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Stasjoner</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-stasjoner_ikke_juridisk'><svg><g><circle cx='12' cy='10' r='8' stroke-width='2'></circle><circle cx='12' cy='10' r='4' stroke-width='2'></circle></g></svg></div><div class='legend-text-w'>Eksisterende T-banestasjon</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-stasjoner_ikke_juridisk_ny'><svg><g><circle cx='12' cy='10' r='8' stroke-width='2'></circle><circle cx='12' cy='10' r='4' stroke-width='2'></circle></g></svg></div><div class='legend-text-w'>Mulig fremtidig T-banestasjon</div></div>",
      ),
    );

    //ct.appendChild(privateFns.appendLegendSection("<strong>Linjesymboler</strong>     "));
    //ct.appendChild(privateFns.appendLegendSection("<strong>Punktsymboler</strong> <div class='legend-row'> <div class='legend-symb legend-symb-point legend-stasjoner_ikke_juridisk_ny'> <svg> <g> <circle cx='12' cy='10' r='8' stroke-width='2'></circle> <circle cx='12' cy='10' r='4' stroke-width='2'></circle> </g> </svg> </div> <div class='legend-text-w'>Fremtidige T-banestasjoner/jernbanestasjoner (ikke juridisk objekt)</div> </div>"));
    return ct;
  },
  kp_pk2_2_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Sikringssoner</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpsikringsone-110'>&nbsp;</div> <div class='legend-text-w'>Nedslagsfelt drikkevann (H 110)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpsikringsone-190'>&nbsp;</div> <div class='legend-text-w'>Andre sikringssoner (restriksjoner for anlegg i grunnen. H 190-1, -2 og -3)</div> </div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Faresoner</strong>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpfaresone-310'>&nbsp;</div> <div class='legend-text-w'>Ras- og skredfare (kvikkleire, H 310-1)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpfaresone-310'>&nbsp;</div> <div class='legend-text-w'>Ras- og skredfare (steinsprang, H 310-2)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpfaresone-310'>&nbsp;</div> <div class='legend-text-w'>Flomfare (stormflo, H 320-1)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpfaresone-310'>&nbsp;</div> <div class='legend-text-w'>Flomfare (elveflom, H 320-2)</div> </div>" +
          "<div class='legend-row'> <div class='legend-symb legend-kpfaresone-310'>&nbsp;</div> <div class='legend-text-w'>Annen fare (deponi, H 390)</div> </div>",
      ),
    );

    return ct;
  },
  kp_tema_juridisk_stoy_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Støy</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-220'>&nbsp;</div><div class='legend-text-w'>Gul støysone vei, L<sub>DEN</sub> 55-65 DB</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-220'>&nbsp;</div><div class='legend-text-w'>Gul støysone bane, L<sub>DEN</sub> 58-68 DB</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-220'>&nbsp;</div><div class='legend-text-w'>Gul støysone havn, L<sub>DEN</sub> 50-60 DB (med impulslyd)</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-220'>&nbsp;</div><div class='legend-text-w'>Gul støysone skytebane, L<sub>AIMAX</sub> 60-70 DB</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-210'>&nbsp;</div><div class='legend-text-w'>Rød støysone vei, L<sub>DEN</sub> > 65 DB</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-210'>&nbsp;</div><div class='legend-text-w'>Rød støysone bane, L<sub>DEN</sub> > 68 DB</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-210'>&nbsp;</div><div class='legend-text-w'>Rød støysone havn, L<sub>DEN</sub> > 60 DB (med impulslyd)</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-veg-210'>&nbsp;</div><div class='legend-text-w'>Rød støysone skytebane, L<sub>AIMAX</sub> > 70 DB</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Avvikssone</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-avvikssone-290'>&nbsp;</div><div class='legend-text-w'>Avvikssone (regionkjerne - regional korridor)</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Stille områder</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-kpstoysone-230'>&nbsp;</div><div class='legend-text-w'>Stille områder</div></div>",
      ),
    );

    return ct;
  },
  kp_tema_ikke_juridisk_luftforurensing_t2_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-gronn'>&nbsp;</div><div class='legend-text-w'>Grønn sone, vintermiddel < 40 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-gul'>&nbsp;</div><div class='legend-text-w'>Gul sone, vintermiddel >= 40 µ/m<sup>3</sup> og årsmiddel < 35 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-oransje'>&nbsp;</div><div class='legend-text-w'>Gul sone, vintermiddel > 40 µ/m<sup>3</sup>  og årsmiddel 35 - 40 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-rod'>&nbsp;</div><div class='legend-text-w'>Rød sone, årsmiddel 40 - 45 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-mrod'>&nbsp;</div><div class='legend-text-w'>Rød sone, årsmiddel >= 45 µ/m<sup>3</sup></div></div>",
      ),
    );

    return ct;
  },
  kp_tema_ikke_juridisk_luftforurensing_t3_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-gronn'>&nbsp;</div><div class='legend-text-w'>Grønn sone < 40 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-gul'>&nbsp;</div><div class='legend-text-w'>Gul sone 35 - 44 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-oransje'>&nbsp;</div><div class='legend-text-w'>Gul sone 45 - 49 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-rod'>&nbsp;</div><div class='legend-text-w'>Rød sone 50 - 54 µ/m<sup>3</sup></div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-luftforurensing-nitrogendioksid-mrod'>&nbsp;</div><div class='legend-text-w'>Rød sone >= 55 µ/m<sup>3</sup></div></div>",
      ),
    );

    return ct;
  },
  kp_tema_juridisk_naturmiljo_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-bandlegging_pbl'>&nbsp;</div><div class='legend-text-w'>Båndlegging for regulering etter plan- og bygningsloven</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-vern_markalvn'>&nbsp;</div><div class='legend-text-w'>Områder vernet etter markaloven</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-vern_naturmangfoldlv'>&nbsp;</div><div class='legend-text-w'>Områder vernet etter naturmangfoldloven</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-natur_a'>&nbsp;</div><div class='legend-text-w'>Naturtyper A-områder</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-natur_b'>&nbsp;</div><div class='legend-text-w'>Naturtyper B-områder</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-natur_c'>&nbsp;</div><div class='legend-text-w'>Naturtyper C-områder</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-naturmiljø-regulert_natur'>&nbsp;</div><div class='legend-text-w'>Områder regulert til naturvernområder/naturområder/naturmiljø</div></div>",
      ),
    );

    return ct;
  },
  kp_tema_ikke_juridisk_kulturminnevern_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-nasjonale_kulturminneinteresser'>&nbsp;</div><div class='legend-text-w'>Områder med nasjonale kulturminneinteresser</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-grense_indre_by'>&nbsp;</div><div class='legend-text-w'>Avgrensing indre by</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-hensyn_bevaring_kulturmiljo'>&nbsp;</div><div class='legend-text-w'>Hensynssone - bevaring kulturmiljø</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-nasjonale_kulturminner'>&nbsp;</div><div class='legend-text-w'>Avklarte nasjonale kulturminner</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-kulturminnevern-nasjonale_kulturminner_bygg'>&nbsp;</div><div class='legend-text-w'>Avklarte nasjonale kulturminner (bygg)</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-vern_indre_kat1'>&nbsp;</div><div class='legend-text-w'>Områder med verneverdi i indre by, kategori 1</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-vern_ytre_kat1'>&nbsp;</div><div class='legend-text-w'>Områder med verneverdi i ytre by, kategori 1</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-vern_ytre_kat2'>&nbsp;</div><div class='legend-text-w'>Områder med verneverdi i ytre by, kategori 2</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-kulturminnevern-regulert_bevaring'>&nbsp;</div><div class='legend-text-w'>Områder regulert til bevaring</div></div>",
      ),
    );

    return ct;
  },
  kp_tema_juridisk_storulykke_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-storulykke-brann_og_eksplosjon'>&nbsp;</div><div class='legend-text-w'>Brann- og eksplosjonsfare</div></div>",
      ),
    );

    return ct;
  },
  kp_tema_juridisk_blaagronn_struktur_legend: function () {
    var ct = creator.createDiv({});
    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong></strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-viktige_kommunikasjonsaarer'>&nbsp;</div><div class='legend-text-w'>Viktige kommunikasjonsårer med eksisterende og nye trær</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-elv_bekk_vann_dam'>&nbsp;</div><div class='legend-text-w'>Elv, bekk, vann, dam</div></div>",
      ),
    );

    ct.appendChild(
      privateFns.appendLegendSection(
        "<strong>Ikke juridiske objekter</strong>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-hovedturvei_eksisterende'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Hovedturvei - eksisterende/planmessig sikret</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-hovedturvei_framtidig'><svg><g><path d='M5 10 l215 0'></path><path d='M5 10 l215 0'></path></g></svg></div><div class='legend-text-w'>Hovedturvei - fremtidig</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-annen_viktig_gangforbindelse'>&nbsp;</div><div class='legend-text-w'>Annen viktig gangforbindelse</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-turdrag_prinsipp'>&nbsp;</div><div class='legend-text-w'>Fremtidig turdrag - prinsipptrasé</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-point legend-blaagronn-krysningspunkt_tiltak'>&nbsp;</div><div class='legend-text-w'>Krysningspunkt som krever tiltak</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-symb-line legend-blaagronn-elv_bekk_prinsipp'>&nbsp;</div><div class='legend-text-w'>Fremtidig elv/bekk - prinsipplassering</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-blaagronn-park_1daa'>&nbsp;</div><div class='legend-text-w'>Område med behov for park på minimum 1 dekar ved byutvikling</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-blaagronn-park_5daa'>&nbsp;</div><div class='legend-text-w'>Område med behov for park på minimum 5 dekar ved byutvikling</div></div>" +
          "<div class='legend-row'><div class='legend-symb legend-blaagronn-park_prinsipp'>&nbsp;</div><div class='legend-text-w'>Framtidig park - prinsipplassering</div></div>",
      ),
    );

    return ct;
  },
  kp: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Kommuneplanen"));
    el.appendChild(
      privateFns.appendParagraph(
        "Kommuneplanen gjelder for hele Oslo kommune og er kommunens overordnede plan. <a href='" +
          kommuneplanDokument +
          "' target='_blank'>Den juridiske arealdelen  <i class='icon-new-window'></i></a> av planen angir hva de ulike arealene skal brukes til. Kommuneplanens arealdel er utarbeidet av Plan- og bygningsetaten på vegne av byrådet og er vedtatt i bystyret. De to plankartene, fire av temakartene (T1, T4, T6 og T7) og planbestemmelsene er juridisk bindende, det vil si lovpålagt å følge. De tre resterende temakartene (T2, T3 og T5) er kun retningsgivende.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "De deler av kommuneplanen som omhandler Marka er oversendt til Klima- og miljødepartementet for endelig godkjenning. Marka-delen av kommuneplanen gjelder følgelig ikke før den er godkjent av departementet.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "For mange av eiendommene gjelder flere planer i tillegg til kommuneplanen.  Ved å trykke på kartet kan du få opp en oversikt over hva som gjelder for punktet eller eiendommen. § 1.2 og § 1.3 i kommuneplanen bestemmer hvordan de ulike planene forholder seg til hverandre:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=19' target='_blank'>§ 1.2 forholdet mellom kommuneplanen og eldre kommunedelplaner <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=19' target='_blank'>§ 1.3 forholdet mellom kommuneplanen og eldre reguleringsplaner <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Reguleringsplaner vedtatt etter kommuneplanen vil gjelde foran kommuneplanen ved motstrid. Det samme gjelder reguleringsplaner vedtatt i perioden fra 17.09.14 og fram til kommuneplanen ble vedtatt 23.09.15.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='//od2.pbe.oslo.kommune.no/pages/legends/legend_kommuneplan.html' target='_blank'>Se tegnforklaring <i class='icon-new-window'></i></a>",
      ),
    );
    return el;
  },
  kp_pk1_2: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Plankart 1-2 Arealbruk"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hva som kan bygges hvor (de ulike formålene). Planen viser også bestemte områder hvor det må tas spesielle hensyn (hensynsoner): bevaring kulturmiljø, båndlegging for regulering – naturmiljø, krav om felles planlegging og omforming.",
      ),
    );

    return el;
  },
  "kp_pk1-2_arealformaal": function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Arealformål"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hva som kan bygges hvor (de ulike formålene).",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='infoark/arealformaal.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.arealformaal_legend());

    return el;
  },
  "kp_pk1-2_arealformaal_utvidet": function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Bebyggelse og anlegg (nåværende)"));
    el.appendChild(
      privateFns.appendParagraph(
        "Områder som er avsatt til bebyggelse og anlegg. Dette kan være boligbebyggelse, fritidsbebyggelse, sentrumsformål, kjøpesenter, forretninger, bebyggelse for offentlige eller privat tjenesteyting, fritids- og turistformål, råstoffutvinning, næringsbebyggelse (f.eks. forretning, kontor), idrettsanlegg, andre typer anlegg, uteoppholdsarealer og grav- og urnelunder.",
      ),
    );
    el.appendChild(privateFns.appendHeader("Bebyggelse og anlegg (fremtidig)"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder som er avsatt til fremtidig bebyggelse og anlegg. Det kan være boligbebyggelse, fritidsbebyggelse, sentrumsformål, kjøpesenter, forretninger, bebyggelse for offentlig og/eller privat tjenesteyting, fritids- og turistformål, råstoffutvinning, næringsbebyggelse, idrettsanlegg, andre typer anlegg, uteoppholdsarealer og grav- og urnelunder. De fleste av disse områdene inngår i utviklingsområder som er inndelt i seks kategorier og merket U–U5:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "utviklingsområder ytre by (U)",
        "sentrum (U1)",
        "sentrumsranden og knutepunkter(U2)",
        "Akerselva og andre områder (U3)",
        "strøksgater (U4)",
        "institusjonelle utviklingsområder (U5)",
      ]),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I tillegg viser plankartet transformasjonsområder i indre by, merket T, og områder som ikke er merket med bokstav. De umerkede områdene er tidligere uregulerte.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om bebyggelse og anlegg (fremtidig): ",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=26' target='_blank'>§ 11 i kommuneplanen <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=20' target='_blank'>§ 3.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(
      privateFns.appendHeader("Samferdselsanlegg og teknisk infrastruktur"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder som er avsatt til samferdselsanlegg og teknisk infrastruktur. Dette kan være veg, bane, lufthavn, havn, hovednett for sykkel, kollektivnett, kollektivknutepunkt, parkeringsplasser og traséer for teknisk infrastruktur.",
      ),
    );
    el.appendChild(privateFns.appendHeader("Grønnstruktur"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder som skal tilrettelegges for opplevelse, rekreasjon, lek og fysisk aktivitet for allmennheten.  Dette kan være naturområder, turdrag, friområder og parker.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om grønnstruktur: "),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=27' target='_blank'>§ 12 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendHeader("Forsvaret"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder hvor Forsvaret har sin militære virksomhet (leirområdene Lutvann, Linderud og Huseby).",
      ),
    );
    el.appendChild(
      privateFns.appendHeader("Landbruks-, natur- og friluftsområder"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder som er avsatt til landbruks-, natur- og friluftsområder. Dette kan være areal for landbruk og gårdstilknyttet næringsvirksomhet og areal for spredt bolig-, fritids- eller næringsbebyggelse. Friluftsområder er arealer som «Marka» eller øyene hvor det ikke skal tilrettelegges aktivt til friluftsliv, men hvor arealene likevel benyttes til dette.",
      ),
    );
    el.appendChild(
      privateFns.appendHeader(
        "Bruk og vern av sjø og vassdrag med tilhørende strandsone",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder som er avsatt til sjø og vassdrag med tilhørende strandsone som skal vernes eller brukes på en bestemt måte. Dette kan være areal for ferdsel, farleder (ferdselsårer i sjø), fiske, akvakultur, drikkevann og natur- og friluftsområder, som badestrender og områder for padling og roing.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om bruk og vern av sjø og vassdrag med tilhørende strandsone:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=28' target='_blank'>§ 13 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    return el;
  },
  "kp_pk1-2_hensynssoner": function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Plankart 1-2 Hensynssoner"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder med bestemte vilkår for utbygging.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='infoark/hensynssoner_1_2.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.hensynssoner_1_2_legend());

    return el;
  },
  "kp_pk1-2_hensynssoner_utvidet": function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Hensynssone bevaring kulturmiljø"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder der det må tas spesielle hensyn for å sikre bevaring av kulturmiljøet. Dette gjelder for bygningsmiljøer på Majorstuen–Fagerborg, Bislett–St. Hanshaugen–Ila og Grünerløkka–Sofienberg.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om hensynssone bevaring kulturmiljø:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>§ 15 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Hensynssone for båndlegging – naturmiljø, H-710",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder der det ikke er tillatt å bygge noe før en ny arealplan er vedtatt.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om båndlegging – naturmiljø, H-710:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>§ 16 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Hensynssoner for krav om felles planlegging, H -810-2",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder med krav om felles planlegging. Det betyr at det ikke er tillatt å bygge før det er laget en plan for hele området. Kommunen kan likevel gjøre unntak fra kravet for",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "større områder hvor det nylig er vedtatt et planprogram/områdeprogram eller andre veiledende dokument som dekker behovet for felles planlegging.",
        "mindre transport- og infrastrukturprosjekter",
        "mindre byggeprosjekter (til- og påbygg, endring/reparasjon av bygning, installasjoner eller anlegg, fasadeendring, bruksendring)",
      ]),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om hensynssoner for krav om felles planlegging, H -810-2:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>§ 17.1 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Hensynssoner for krav om godkjent områderegulering, H -810-1",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette er områder (Stubberud, Furuset, Lysaker/Vækerø/Skøyen og Gjersrud-Stensrud) med krav om godkjent områderegulering. Det betyr at det ikke er tillatt å bygge før det er vedtatt en områderegulering for hele området. Kommunen kan likevel gjøre unntak fra dette kravet for tiltak og detaljreguleringer som ikke vanskeliggjør påfølgende regulering og utbygging, og som er i samsvar med kommuneplanens bestemmelser og retningslinjer.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om hensynssoner for krav om godkjent områderegulering, H -810-1:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=19' target='_blank'>§ 3 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader("Hensynssone for høyspentlinje (H-820-1)"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "H-820-1: Høyspentlinjer som skal fornyes eller oppgraderes i disse områdene, bør legges i jordkabel.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om hensynssoner for høyspentlinjer:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>§ 17.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader("Hensynssone for trafostasjoner (H-820-2)"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Trafostasjoner som skal etableres eller ombygges i disse områdene, skal bygges som gassisolerte anlegg hvis det er mulig.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om hensynssoner for trafostasjoner:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>§ 17.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    return el;
  },
  "kp_pk1-2_juridisk": function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Juridiske linjer og symboler"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser linjer og symboler som er bestemt i kommuneplanen.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.juridisk_legend());

    return el;
  },
  "kp_pk1-2_ikke_juridisk": function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Ikke juridiske objekter"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser objekter som er veiledende i kommuneplanen.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.ikke_juridisk_legend());

    return el;
  },
  kp_pk2_2: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Plankart 2-2"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette plankartet viser flere områder hvor det må tas spesielle hensyn (hensynssoner) ved gjennomføring av tiltak. Dette er områder med restriksjoner for anlegg i grunnen, nedslagsfelt for drikkevann, deponi eller fare for steinsprang, stormflo, elveflom eller kvikkleire.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='infoark/hensynssoner_2_2.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_pk2_2_legend());
    return el;
  },
  kp_pk2_2_utvidet: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Nedslagsfelt drikkevann, H 110"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hensynssoner rundt drikkevannskilder. Her er det ikke tillatt med tiltak som kan forurense drikkevannet.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dagens drikkevannskilder er Maridalsvassdraget, Elvågavassdraget, Langliavassdraget og Alnsjøvassdraget.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om nedslagsfelt for drikkevann:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=29' target='_blank'>§ 14.1 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Andre sikringssoner H 190-1, -2 og -3 (restriksjoner for anlegg i grunnen)",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hensynssoner med restriksjoner for sprengning og brønnboring i grunnen. Hensikten er å sikre arealer for eksisterende og fremtidige tunneler.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om andre sikringssoner:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=29' target='_blank'>§ 14.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(privateFns.appendHeader("Ras- og skredfare,H 310 1-2"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hensynssoner med mulig fare for større kvikkleireskred (H 310-1), og hvor det kan være fare for steinsprang (H 310-2). Tiltak i disse sonene må gjennomføres med nødvendige sikringstiltak.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om kvikkleireskred og steinsprang:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=29' target='_blank'>kommuneplanen § 14.3 første ledd om kvikkleireskred <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class=icon-new-window'></i></a>",
        "<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_kvikkleireskred.html' target='_blank'>faktaark kvikkleireskred <i class='icon-new-window'></i></a>",
        "<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_steinsprang.html' target='_blank'>faktaark steinsprang <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(privateFns.appendHeader("Flomfare, H 320 1-2"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hensynssoner hvor det kan være fare for stormflo (H 320-1) og hvor det kan være fare for elveflom (H 320-2) hvor det må gjennomføres særskilte avbøtende tiltak.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Her kan du lese mer om stormflo og elveflom:",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>kommuneplanen § 14.4 første ledd om hensynsone stormflo og elveflom <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=104' target='_blank'>vedlegg 2 til kommuneplanen om ROS-analyse, kapittel 17.2 <i class='icon-new-window'></i></a>",
        "<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_elveflom.html' target='_blank'>faktaark om elveflom <i class='icon-new-window'></i></a>",
      ]),
    );

    el.appendChild(privateFns.appendHeader("Annen fare, H 390 (deponi)"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser hensynssonen for forurenset grunn som omfatter de tre tidligere avfallsfyllingene Grønmo, Stubberud og Rommen. I disse områdene må det gjennomføres opprydding/sikring i grunnen før tiltaket gjennomføres.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om deponi:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=30' target='_blank'>kommuneplanen § 14.5 <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=64' target='_blank'>kommuneplanen kap. 12 om hensynssoner <i class='icon-new-window'></i></a>",
      ]),
    );

    return el;
  },
  kp_tema_juridisk_stoy: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Støy"));
    el.appendChild(privateFns.appendSubHeader("Støy"));
    el.appendChild(
      privateFns.appendParagraph(
        "Dette plankartet viser beregnet støy fra vei, bane og havn som gule og røde støysoner. Plankartet viser også en avvikssone, der man kan avvike fra støykravene, samt stille områder",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Avvikssone"));
    el.appendChild(
      privateFns.appendParagraph(
        "I disse områdene kan støyfølsom bebyggelse plasseres i gul/rød sone dersom man oppfyller vilkårene i § 7.1 i kommuneplanen.",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Stille områder"));
    el.appendChild(
      privateFns.appendParagraph(
        "Stille områder består som regel av friluftsområder, turveier og parker. Dersom dere skal etablere eller utvide støyende virksomhet nær stille områder, må virksomheten plasseres og utformes slik at støynivået forblir uendret eller dempes.",
      ),
    );
    el.appendChild(privateFns.appendParagraph("Her kan du lese mer om støy:"));
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=23' target='_blank'>§ 7.1 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_juridisk_stoy_legend());

    return el;
  },
  kp_tema_ikke_juridisk_luftforurensing_t2: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader(
        "Luftforurensing - nitrogendioksid (retningsgivende)",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser beregnet konsentrasjon av gassen nitrogendioksid (NO2). Fargeskalaen viser tettheten av gassen, hvor grønn er lavest og rød høyest. For prosjekter som er følsomme for luftforurensing skal det vurderes tiltak for å sikre luftkvalitet.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om luftforurensing:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_ikke_juridisk_luftforurensing_t2_legend());
    return el;
  },
  kp_tema_ikke_juridisk_luftforurensing_t3: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Luftforurensing - svevestøv (retningsgivende)"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser beregnet konsentrasjon av svevestøv, partikler som har en diameter under 10 mikrometer (PM10). Fargeskalaen viser tettheten av partikler, hvor grønn er lavest og rød høyest.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om luftforurensing:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=23' target='_blank'>§ 7.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_ikke_juridisk_luftforurensing_t3_legend());

    return el;
  },
  kp_tema_juridisk_naturmiljo: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Naturmiljø"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder med verdifull natur, og hvordan den er sikret eller skal sikres på forskjellig måter.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='infoark/t4_naturmiljo.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_juridisk_naturmiljo_legend());
    return el;
  },
  kp_tema_juridisk_naturmiljo_utvidet: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader(
        "Båndlegging for regulering etter plan- og bygningsloven",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder som kommuneplanen båndlegger i påvente av sikring gjennom reguleringsplan etter plan- og bygningsloven.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Områder vernet etter markaloven"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder som er vernet etter markaloven hvor fylkesmannen og Klima- og miljødepartementet må gi tillatelse til planlegging og gjennomføring av visse tiltak.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader("Områder vernet etter naturmangfoldloven"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder som er vernet etter naturmangfoldloven hvor fylkesmannen og Klima- og miljødepartementet må gi tillatelse til planlegging og gjennomføring av visse tiltak.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Naturtyper A-områder"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser naturmiljøer med nasjonal verdi. De er ikke tillatt med tiltak som kan skade naturverdiene.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Naturtyper B-områder"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser naturmiljøer med regional verdi, hvor det skal særlige grunner til å tillate tiltak som kan skade naturverdiene.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Naturtyper C-områder"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser naturmiljøer med lokal verdi, hvor tiltak som kan skade naturverdiene, bør unngås.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Områder regulert til naturvernområder/naturområder/naturmiljø",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder som er sikret gjennom reguleringsplan etter plan- og bygningsloven.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader("Her kan du lese mer om naturmiljø:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=24' target='_blank'>§ 7.6 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    return el;
  },
  kp_tema_ikke_juridisk_kulturminnevern: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Kulturminnevern (retningsgivende)"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Dette plankartet gir en oversikt over områder og objekter, for eksempel bygninger, med ulik bevaringsverdi, eller kulturminneinteresser.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='infoark/t5_kulturminnevern.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_ikke_juridisk_kulturminnevern_legend());

    return el;
  },
  kp_tema_ikke_juridisk_kulturminnevern_utvidet: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader("Områder med nasjonale kulturminneinteresser"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I områder med nasjonal kulturminneinteresse er målet å ta vare på bevaringsverdiene. Saksbehandlingen vil avklare graden av bevaring. Nye bygninger som grenser til bygg eller anlegg med nasjonal verneverdi, bør plasseres og utformes slik at man viderefører viktige elementer i eksisterende gate-, byroms- og bebyggelsesstruktur.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Eksempler: Kvadraturen, Kampen, Ullevål Hageby, Slottet og Stortinget.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Avgrensning indre by"));
    el.appendChild(
      privateFns.appendParagraph(
        "Områdene innenfor denne avgrensningen defineres som indre by. Områdene utenfor defineres som ytre by.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Hensynssone bevaring kulturmiljø"));
    el.appendChild(
      privateFns.appendParagraph(
        "Denne kategorien inneholder spesielt verdifulle bygningsmiljøer på Majorstuen–Fagerborg, Bislett–St. Hanshaugen–Ila og Grünerløkka–Sofienberg. I disse områdene er målet å sikre kulturminneinteressene. Nye tiltak skal derfor plasseres og utformes slik at man viderefører viktige elementer i eksisterende gate-, byroms- og bebyggelsesstruktur. Bygninger med nasjonalt og regionalt viktige kulturminneverdier bør bevares.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Avklarte nasjonale kulturminner"));
    el.appendChild(
      privateFns.appendParagraph(
        "Denne kategorien omfatter bygninger og anlegg med avklart nasjonal verdi som skal bevares. Nasjonal verneverdi kan være nasjonale vernevedtak, statlig listeføring eller automatisk fredning.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Eksempler: Frognerparken, Trefoldighetskirken og Birkelunden.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Områder regulert til bevaring"));
    el.appendChild(
      privateFns.appendParagraph(
        "Hensikten med å regulere et område til bevaring er å sikre kulturminneverdiene området. I områder som er regulert til bevaring, er det egne reguleringsplaner med bestemmelser som legger føringer for hvilke endringer som kan tillates på eksisterende bebyggelse. I noen tilfeller sier bestemmelsene også noe om hvilke typer nybygg som kan tillates i området. Områder som er regulert til bevaring, er vernet etter plan- og bygningsloven og har dermed et formelt vern.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Områder med verneverdi i indre by. Kategori 1 indre by",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I områdene i denne kategorien er målet å sikre bevaringsverdiene. Det betyr at nye tiltak bør plasseres og utformes på en måte som gjør at man viderefører viktige elementer i eksisterende gate-, byroms-, og bebyggelsesstrukturer.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Eksempler: NRK på Marienlyst og Vår frelsers gravlund.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader(
        "Områder med verneverdi i ytre by. Kategori 1 ytre by",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "I disse områdene er målet å sikre bevaringsverdiene. Det betyr at nye tiltak bør plasseres og utformes på en måte som gjør at man viderefører viktige elementer i eksisterende gate-, byroms- og bebyggelsesstrukturer.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Eksempler: Ammerud og Husebygrenda."),
    );

    el.appendChild(privateFns.appendHeader("Kategori 2 ytre by"));
    el.appendChild(
      privateFns.appendParagraph(
        "I disse områdene er målet å ta vare på bevaringsverdiene samtidig som områdene skal videreutvikles. Hensynet til bevaring skal veies opp mot andre hensyn i plan- og bygningsloven.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Eksempler: Lambertseter, Ekeberg–Nordstrand. ",
      ),
    );

    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om kulturmiljø:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=24' target='_blank'>§ 8 i kommuneplanen <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=20' target='_blank'>§ 3.2 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );
    return el;
  },
  kp_tema_juridisk_storulykke: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Storulykkebedrifter"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder med særlig stor brann- og eksplosjonsfare rundt storulykkebedrifter. En storulykkevirksomhet er en virksomhet hvor det arbeides med giftige og farlige kjemikalier over en viss mengde. Størrelsen på sonene varierer og bygger på en faglig vurdering av hver enkelt virksomhet innenfor rammene av gjeldende lovverk.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om storulykkebedrifter:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=25' target='_blank'>§ 9.2 i kommuneplanen <i class='icon-new-window'></i></a>",
        "<a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/faktaark_storulykke.html' target='_blank'>faktaark om storulykker <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_juridisk_storulykke_legend());

    return el;
  },
  kp_tema_juridisk_blaagronn_struktur: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Blågrønn struktur"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser viktige veier og gater hvor det skal tas vare på eksisterende trær eller plantes nye trær dersom det er mulig. Videre vises vassdrag, eksisterende og fremtidige turveier, områder med behov for park, prinsipplassering av fremtidige parker, fremtidige turdrag, fremtidige elver og bekker.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://od2.pbe.oslo.kommune.no/pages/infoark/t6_blaagronn_struktur.html' target='_blank'>Les mer <i class='icon-new-window'></i></a>",
      ),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(getInfo.kp_tema_juridisk_blaagronn_struktur_legend());
    return el;
  },
  kp_tema_juridisk_blaagronn_struktur_utvidet: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader(
        "Viktige kommunikasjonsårer med eksisterende og nye trær",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser strekninger hvor det skal tas vare på eksisterende trær eller plantes nye trær dersom det er mulig.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Elv, bekk, vann, dam"));
    el.appendChild(
      privateFns.appendParagraph(
        "Åpne strekninger av elver, bekker, vann og dammer skal opprettholdes.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Hovedturvei"));
    el.appendChild(
      privateFns.appendParagraph("Plankartet viser tre kategorier av turvei:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<i>eksisterende turvei</i> som enten er opparbeidet eller regulert",
        "<i>fremtidig turvei</i> som forutsettes sikret gjennom regulering ved byutvikling",
        "<i>annen viktig gangforbindelse</i> som ikke er mulig å opparbeide til et sammenhengende grønt område med tursti (turdrag), men som likevel er viktig å opparbeide fremover for å sikre sammenheng i turveinettet.",
      ]),
    );

    el.appendChild(
      privateFns.appendHeader("Fremtidig turdrag – prinsipptrasé"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder som gjennom byutvikling skal utvikles til et sammenhengende grønt område med tursti (turdrag), slik at natur- og landskapskvaliteter videreutvikles og økologiske sammenhenger styrkes.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader("Områder med behov for park på minst 1 daa"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Hvis det bygges prosjekter som enkeltvis eller samlet omfatter 20 000 m² BRA eller mer i disse områdene, bør det etableres park på minst 1 dekar.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader("Områder med behov for park på minimum 5 daa"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Hvis det bygges prosjekter som enkeltvis eller samlet omfatter 40 000 m² BRA eller mer i disse områdene, bør det etableres park på minst 5 dekar.",
      ),
    );

    el.appendChild(privateFns.appendHeader("Krysningspunkt som krever tiltak"));
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser steder der turveier krysser trafikkerte veier. Her skal det sikres trafikksikker krysning som gir prioritet til turveien.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader("Fremtidig elv/bekk – prinsipptrasé"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser elver og bekker som bør gjenåpnes.",
      ),
    );

    el.appendChild(
      privateFns.appendHeader("Fremtidig park – prinsipplassering"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Plankartet viser områder hvor det planlegges park, og prinsipplassering er avklart.",
      ),
    );

    el.appendChild(
      privateFns.appendParagraph("Her kan du lese mer om blågrønn struktur:"),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='" +
          kommuneplanDokument +
          "#page=27' target='_blank'>§ 12.3 i kommuneplanen <i class='icon-new-window'></i></a>",
        "<a href='" +
          kommuneplanDokument +
          "#page=28' target='_blank'>§ 13.3 i kommuneplanen <i class='icon-new-window'></i></a>",
      ]),
    );

    return el;
  },
  blagronn_faktor: function () {
    var el = creator.createDiv({});
    el.appendChild(
      privateFns.appendHeader(
        "Norm for vegetasjon og vannhåndtering (blågrønn faktor) i Oslo",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Oslo kommune ønsker mer åpen overvannshåndtering og mer vegetasjon i byen. Vi har derfor tatt i bruk norm for vegetasjon og vannhåndtering (blågrønn faktor). Normen er et verktøy for å styrke byens blågrønne preg og strukturer, naturmangfold og for å skape et godt byliv.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Normen er særlig viktig for å sette byen i stand til å tåle mye regn, regn som ellers kan føre til oversvømmelser, flom og ras. Bruk av normen vil fremme trygg og lokal åpen overvannshåndtering gjennom flere grønne tak og vegger, flere trær, mer urbant landbruk og liknende. Bruk vil også bidra til renere overflatevann, mindre luftforurensning og økt støydemping fra trafikk.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Normen trådte i kraft for boligprosjekter i 2019. Forslag til revidert og utvidet norm ble behandlet og tatt til orientering i bystyret 27.09.2023. En utvidet norm betyr at den fra nå ikke bare gjelder for boligprosjekt, men en rekke andre bygge- og samferdselsformål.",
      ),
    );
    el.appendChild(
      privateFns.appendList([
        "<a href='https://www.oslo.kommune.no/get-file/110905/561948e2a426a658803b2a03c6fb495c263a07fc11145054729283ede281350c' target='_blank'>Norm for vegetasjon og vannhåndtering (blågrønn faktor) <i class='icon-new-window'></i></a>",
        "<a href='https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.oslo.kommune.no%2Fget-file%2F110904%2F39712493408195286349b45016d7560cbbdb56cab808380d42c7b27f708a51e9&wdOrigin=BROWSELINK' target='_blank'>Regneark <i class='icon-new-window'></i></a>",
        "<a href='https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fwww.oslo.kommune.no%2Fget-file%2F110903%2Fcf5a0e7561ebd7071fba58262029436e9b9fa47ac616500dd60b21332ab83fbe&wdOrigin=BROWSELINK' target='_blank'>Regneark for småhusområder <i class='icon-new-window'></i></a>",
        "<a href='https://www.oslo.kommune.no/get-file/110906/2bc84dab3d754cbae09a7c511ebd417b69d4a8d2460c85136dd9bad07c71469f' target='_blank'>Brukerveiledning <i class='icon-new-window'></i></a>",
      ]),
    );
    el.appendChild(privateFns.appendSubHeader("Tegnforklaring"));
    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=BLAGRONNFAKTOR&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=blagronn_faktor&format=image/png&STYLE=default",
      ),
    );

    return el;
  },
  reklameomrader: function () {
    var el = creator.createDiv({});
    el.appendChild(privateFns.appendHeader("Skilt- og reklameplan for Oslo"));
    el.appendChild(
      privateFns.appendParagraph(
        "Skilt- og reklameplanen for Oslo inneholder retningslinjer for hvilke skilt- og reklameinnretninger som kan settes opp. De juridisk bindende retningslinjene består av generelle regler og spesifikke regler for ulike områder i indre by.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "De generelle retningslinjene gjelder for hele den bebygde delen av Oslo. Det er i tillegg regler for fem ulike områdetyper, i hovedsak innenfor Ring 2. Dette kan du se på kartet. I de ulike områdene er det forskjellige regler ut fra hvilken rolle områdene har, tyngden av næring og hvor sårbart området er for reklame.",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4' target='_blank'>Her kan du lese mer om Skilt- og reklameplanen for Oslo<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(privateFns.appendSubHeader("Generelle retningslinjer"));
    el.appendChild(
      privateFns.appendParagraph(
        "Gjelder for hele Oslo. <a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=48' target='_blank'>Se retningslinjenes punkt 6.1-6.28 i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendSubHeader("Reklameområde XS (sårbare områder):"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Områder med lite næringsaktivitet, høy sårbarhet og prioritering av aktiviteter for fellesskapet. Reklameområde XS skal ikke ha reklame, bortsett fra det som tillates i retningslinjenes pkt. 7.1. <a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=50' target='_blank'> Se retningslinjenes punkt 7.1 i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendSubHeader("Reklameområde S (boligdominerte områder):"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Områder hvor det i hovedsak er boliger, og der det er lite til middels næringsaktivitet. I reklameområde S skal stedlige virksomheter kunne eksponere seg med skilt og mindre reklame – så lenge det ikke sjenerer de som bor der i særlig stor grad. Med reklame for stedlig virksomhet menes reklame som gjelder den virksomheten som holder til i bygningen/eiendommen hvor reklamen plasseres. <a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=50' target='_blank'>Se retningslinjenes punkt 7.2 i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendSubHeader(
        "Reklameområde M (områder med blandede funksjoner):",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Områder med middels til høy næringsaktivitet og med færre boliger. I reklameområde M skal skilt og reklame speile variasjonen i området. <a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=51' target='_blank'>Se retningslinjenes punkt 7.3 i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendSubHeader("Reklameområde L (næringsdominerte områder):"),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "Områder med høy næringsaktivitet inkludert næringsområder med estetisk og historisk betydning, og arenaer for idrett og rekreasjon. I reklameområde L skal næringsvirksomheter kunne eksponeres tydelig. <a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=52' target='_blank'>Se retningslinjenes punkt 7.4 i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendSubHeader(
        "Transformasjonsområder T(arealer for senere planlegging og omdanning):",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=48' target='_blank'>Se generelle retningslinjer, punkt 6.3-6.28, i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendSubHeader(
        "Egne bestemmelser for Karl Johans gate og Stortingsgata",
      ),
    );
    el.appendChild(
      privateFns.appendParagraph(
        "<a href='https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=52' target='_blank'>Se retningslinjenes punkt 7.5 i Skilt- reklameplanen for Oslo.<i class='icon-new-window'></i></a>",
      ),
    );

    el.appendChild(
      privateFns.appendLegendImage(
        "https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=SKILTREKLAME&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Reklameomrader&format=image/png&STYLE=default",
      ),
    );

    return el;
  },
};

export default {
  getInfoTextFor: function (id) {
    if (getInfo[id]) {
      if (typeof getInfo[id] === "function") {
        return getInfo[id];
      } else {
        var el = creator.createDiv({});
        getInfo[id].forEach(function (elm) {
          var appendix = privateFns.createElement(elm);
          el.appendChild(appendix);
        });
        return el;
      }
    } else {
      return;
    }
  },
  getInfoFeature: function (id) {
    return getInfo[id];
  },
  addInfoTextFor: function (id, array) {
    getInfo[id] = array;
    return getInfo;
  },
};
